// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.menu-logo[data-v-260a012e] {\n    max-width: 150px;\n    margin: 0 auto;\n}\n@media only screen and (min-width: 960px) {\n#mobile-nav-drawer[data-v-260a012e],\n    #mobile-web-navigation[data-v-260a012e] {\n        display: none;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
